import { lazy } from 'react';

const Profile = lazy(() => import('./Profile'));

export { Profile };
